import angular from 'angular';
import Cooperative from '../core/data/cooperative.data';
import gridHeight from '../core/shared-service/grid-utils';

class listCooperativesCommunityCtrl {
    /*  @ngInject */

    constructor($state, logger, CooperativeSvc, AuthSvc, $scope, $translate, $stateParams) {
        this.$state = $state;
        this.logger = logger;
        this.AuthSvc = AuthSvc;
        this.CooperativeSvc = CooperativeSvc;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
    }

    $onInit() {
        this.isAuthorizedToCreate = this.AuthSvc.isAuthorized('CONFIGURATOR');
        const eid = this.$stateParams.eid;
        let paginationOptions = {
            pageNumber: 0,
            pageSize: 20,
            sort: null,
        };

        this.containerPromise = this.CooperativeSvc.getAllCooperativesOfCommunity(
            eid,
            paginationOptions.pageNumber,
            paginationOptions.pageSize
        );
        this.cooperatives = [];
        this.containerPromise.then(
            data => {
                if (data.data.content) {
                    data.data.content.forEach(coo => this.cooperatives.push(new Cooperative(coo, this.$translate)))
                    this.gridOptions.data = this.cooperatives;
                    this.gridOptions.totalItems = data.data.totalElements;
                }
            },
            () => {
                this.logger.error('error.search');
            }
        );
        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="community.details.groupement-update({ id : row.entity.id })">' +
            '<div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'code',
                    displayName: 'Code du groupement',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'name',
                    displayName: 'Nom du groupement',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'getStatusLabel()',
                    displayName: 'Statut',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                }
            ],
            paginationPageSizes: [20, 50, 100],
            paginationPageSize: paginationOptions.pageSize,
            useExternalPagination: true,
            exporterCsvColumnSeparator: ';',
            exporterOlderExcelCompatibility: true,
            exporterHeaderFilter: this.$translate.instant,
            gridMenuTitleFilter: this.$translate,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
                gridApi.pagination.on.paginationChanged(this.$scope, (newPage, pageSize) => {
                    paginationOptions.pageNumber = newPage;
                    paginationOptions.pageSize = pageSize;
                    this.containerPromise = this.CooperativeSvc.getAllCooperativesOfCommunity(eid, newPage, pageSize);
                    this.containerPromise.then(
                        data => {
                            this.gridOptions.data = data.data.content;
                            this.gridOptions.totalItems = data.data.totalElements;
                        },
                        () => {
                            this.logger.error('error.search');
                        }
                    );
                });
            },
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
        };
    }

    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }
    goBack() {
        this.$state.go('community.list.main');
    }
    goNewCooperative() {
        this.$state.go('community.details.groupement-create');
    }
    goEditCooperative() {
        this.$state.go('community.details.groupement-update');
    }
}

angular.module('app.community').component('listCooperativesCommunity', {
    templateUrl: require('./list-cooperatives-community.html'),
    controller: listCooperativesCommunityCtrl,
    bindings: {}
});
